<template>

  <el-card class="plain-card adv-detail">

    <div slot="header">
      <h1 class="has-operation">
        <span>单号：234231029431</span>
        <el-button-group>
          <el-button plain icon="el-icon-edit">操作1</el-button>
          <el-button plain icon="el-icon-share">操作2</el-button>
          <el-button type="primary">主操作</el-button>
        </el-button-group>
      </h1>
      <div class="header-index-content">
        <div class="detail-list-container">
          <detail-list :col="2">
            <detail-list-item term="下单人">付小小</detail-list-item>
            <detail-list-item term="联系电话">18100000001</detail-list-item>
            <detail-list-item term="常用快递">菜鸟仓储</detail-list-item>
            <detail-list-item term="收货地址">浙江省杭州市西湖区万塘路19号</detail-list-item>
          </detail-list>
        </div>
      </div>
    </div>

    <el-card>
      <div slot="header">流程进度</div>
      <el-steps :active="1">
        <el-step title="步骤 1" description="这是一段很长很长很长的描述性文字"></el-step>
        <el-step title="步骤 2" description="这是一段很长很长很长的描述性文字"></el-step>
        <el-step title="步骤 3" description="这段就没那么长了"></el-step>
      </el-steps>
    </el-card>

    <el-card>
      <div slot="header">用户信息</div>
      <div class="detail-list-container">
        <detail-list>
          <detail-list-item term="用户姓名">付小小</detail-list-item>
          <detail-list-item term="联系电话">18100000001</detail-list-item>
          <detail-list-item term="常用快递">菜鸟仓储</detail-list-item>
          <detail-list-item term="取货地址">浙江省杭州市西湖区万塘路19号</detail-list-item>
          <detail-list-item term="备注">无</detail-list-item>
        </detail-list>
      </div>
    </el-card>

    <el-card>
      <div slot="header">退货商品</div>
      <el-table class="table" :data="goodsData">
        <el-table-column prop="id" label="商品编号" />
        <el-table-column prop="name" label="商品名称" />
        <el-table-column prop="price" label="商品价格" :formatter="$tableHelper.fmts.price" />
        <el-table-column prop="num" label="商品数量" />
        <el-table-column prop="amount" label="总计" :formatter="$tableHelper.fmts.price" />
      </el-table>
    </el-card>

    <el-card>
      <el-tabs value="first">
        <el-tab-pane label="操作日志一" name="first">
          <el-table class="table" :data="goodsData">
            <el-table-column prop="id" label="商品编号" />
            <el-table-column prop="name" label="商品名称" />
            <el-table-column prop="price" label="商品价格" :formatter="$tableHelper.fmts.price" />
            <el-table-column prop="num" label="商品数量" />
            <el-table-column prop="amount" label="总计" :formatter="$tableHelper.fmts.price" />
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="操作日志二" name="second">
          <el-table class="table" :data="goodsData">
            <el-table-column prop="id" label="商品编号" />
            <el-table-column prop="name" label="商品名称" />
            <el-table-column prop="price" label="商品价格" :formatter="$tableHelper.fmts.price" />
            <el-table-column prop="num" label="商品数量" />
            <el-table-column prop="amount" label="总计" :formatter="$tableHelper.fmts.price" />
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="操作日志三" name="third">
          <el-table class="table" :data="goodsData">
            <el-table-column prop="id" label="商品编号" />
            <el-table-column prop="name" label="商品名称" />
            <el-table-column prop="price" label="商品价格" :formatter="$tableHelper.fmts.price" />
            <el-table-column prop="num" label="商品数量" />
            <el-table-column prop="amount" label="总计" :formatter="$tableHelper.fmts.price" />
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-card>

  </el-card>

</template>

<script>
const goodsData = [
  {
    id: '1234561',
    name: '矿泉水 550ml',
    barcode: '12421432143214321',
    price: '2.00',
    num: '1',
    amount: '2.00'
  },
  {
    id: '1234562',
    name: '凉茶 300ml',
    barcode: '12421432143214322',
    price: '3.00',
    num: '2',
    amount: '6.00'
  },
  {
    id: '1234563',
    name: '好吃的薯片',
    barcode: '12421432143214323',
    price: '7.00',
    num: '4',
    amount: '28.00'
  },
  {
    id: '1234564',
    name: '特别好吃的蛋卷',
    barcode: '12421432143214324',
    price: '8.50',
    num: '3',
    amount: '25.50'
  }
]
export default {
  data() {
    return {
      goodsData
    }
  }
}
</script>
